import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid, Tooltip, Snackbar, Alert } from '@mui/material';

function CardCompany({ tax_id, name, company_Email, key_ops, address_th, tel }) {
  const [companyData, setCompanyData] = useState({
    tax_id: '',
    name: '',
    company_Email: '',
    key_ops: '',
    address_th: '',
    tel: ''
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setOpenSnackbar(true);
    });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    setCompanyData({
      tax_id: tax_id,
      name: name,
      company_Email: company_Email,
      key_ops: key_ops,
      address_th: address_th,
      tel: tel
    });
  }, [tax_id, name, company_Email, key_ops, address_th, tel]);

  return (
    <>
    <Card>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography component="div" sx={{ mb: 1 }}>
              <span style={{ fontWeight: 500 }}>เลขประจำตัวผู้เสียภาษี: </span>
              <span style={{ color: '#4FA893' }}> {companyData.tax_id}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography component="div" sx={{ mb: 1 }}>
              <span style={{ fontWeight: 500 }}>ชื่อบริษัท: </span>
              <span style={{ color: '#4FA893' }}> {companyData.name}</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography sx={{ mb: 1 }}>
              <span style={{ fontWeight: 500 }}>Key ops: </span>
                {companyData.key_ops.length <= 50 ? (
                  <Tooltip title="คลิกเพื่อคัดลอก" arrow>
                    <span onClick={() => handleCopy(companyData.key_ops)} style={{ color: '#4FA893' }}> {companyData.key_ops}</span>
                  </Tooltip>
                ) : (
                  <Tooltip title="คลิกเพื่อคัดลอก" arrow>
                    <span 
                    onClick={() => handleCopy(companyData.key_ops)}
                    class='text-[#4FA893] inline-block max-w-[300px] whitespace-nowrap overflow-hidden text-ellipsis align-bottom'>
                      {companyData.key_ops}
                    </span>
                  </Tooltip>
                )}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ mb: 1 }}>
              <span style={{ fontWeight: 500 }}>Email: </span>
              <span style={{ color: '#4FA893' }}> {companyData.company_Email}</span>
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Typography sx={{ mb: 1 }}>
              <span style={{ fontWeight: 500 }}>ที่อยู่บริษัท: </span>
              <span style={{ color: '#4FA893' }}> {companyData.address_th || '-'}</span>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ mb: 1 }}>
              <span style={{ fontWeight: 500 }}>เบอร์โทรศัพท์: </span>
              <span style={{ color: '#4FA893' }}> {companyData.tel || '-'}</span>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>

    <Snackbar
      open={openSnackbar}
      autoHideDuration={1500}
      onClose={handleCloseSnackbar}
    >
      <Alert
        severity="success"
        variant="filled"
        sx={{ width: '100%', color: '#FFFFFF'}}
      >
        คัดลอกข้อความแล้ว
      </Alert>
    </Snackbar>

    </>
  );
}

export default CardCompany;
